import HandoffListTable from './handoffListTable.container';

export default HandoffListTable